<template>
<div id="newsletter-recipient">
  <div
     v-if="recipient.id"
    >
    <h2>Newsletter Recipient #{{ recipient.id }}</h2>

    <newsletter-nav
      :newsletterId="newsletterId"
    ></newsletter-nav>

    <table class="table">
      <tr>
        <td>
          Newsletter
        </td>
        <td>
          <router-link :to="{
            name: 'newsletter',
            params: {
              newsletterId: recipient.newsletter_id
            }
          }">
            #{{ recipient.newsletter_id }}
          </router-link>
        </td>
      </tr>
      <tr>
        <td>
          Subscriber
        </td>
        <td>
          <router-link :to="{
            name: 'newsletter_type_subscriber',
            params: {
              newsletterTypeSubscriberId: recipient.newsletter_type_subscriber_id
            }
          }">
            #{{ recipient.newsletter_type_subscriber_id }}
          </router-link>
        </td>
      </tr>
    </table>
  </div>

  <email-recipient
    :newsletterId="newsletterId"
    :recipientId="newsletterRecipientId"
    ref="emailRecipient"
  />
</div>
</template>

<script>
import EmailRecipient from '@/components/EmailRecipient'

import NewsletterNav from '@/components/NewsletterNav'

export default {
  data () {
    return {
      recipient: {}
    }
  },

  components: {
    'email-recipient': EmailRecipient,
    'newsletter-nav': NewsletterNav
  },

  props: {
    newsletterId: {
      type: [ Number, String ],
      default: undefined,
      required: true
    },

    newsletterRecipientId: {
      type: [ Number, String ],
      default: undefined,
      required: true
    }
  },

  mounted () {
    this.$refs['emailRecipient'].$on('loaded', recipient => {
      this.recipient = recipient
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/NewsletterRecipient.vue